import useGet from "../../hooks/useGet";
import Table from "../../components/table";
import columns from "./column";
import useTable from "../../hooks/useTable";
import CardContainer from "../../components/card_container";
import {
  ADDSTYLEOPTIONS,
  EDITSTYLEOPTIONS,
  DETAILSTYLEOPTIONS
} from "../../routes/routes_name";
import CustomModal from "../../components/custom_modal";
import { useState } from "react";
import DetailStyleOptionsPage from "./detail";

const StyleOptionsPage = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const {
    filter,
    isLoading,
    data,
    error,
    totalPages,
    handlePagination,
    handleLimit,
    handleFilter,
  } = useGet("/v1/style_options", 10);

  const {
    isLoading: isLoadingPost,
    dataRemove,
    handleEdit,
    handleSelected,
    handleRemove,
  } = useTable();

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <>
      <CardContainer
        title="List of Style Options"
        isHeader={true}
        addShow={dataRemove.length < 1}
        editShow={dataRemove.length === 1}
        detailShow={dataRemove.length === 1}
        deleteShow={dataRemove.length >= 1}
        addClick={ADDSTYLEOPTIONS}
        searchPlaceholder="Search Style Options"
        editClick={() => handleEdit(EDITSTYLEOPTIONS)}
        detailClick={() => openModal()}
        deleteClick={() =>
          handleRemove({
            url: "/v1/style_options",
            descSuccess: "Style Options data has been successfully deleted.",
          })
        }
        onSearchChange={handleFilter}
      >
        <div className="expanded-y">
          <div className="table-content">
            <Table
              filter={filter}
              isLoading={isLoading}
              error={error}
              data={data}
              totalPages={totalPages}
              handlePagination={handlePagination}
              handleLimit={handleLimit}
              handleChangeSelect={handleSelected}
              columns={columns}
            />
          </div>
        </div>
      </CardContainer>
      <CustomModal
        title={"Detail Style Options"}
        titleBtnOutline={"Edit"}
        onClikBtnOutline={() => handleEdit(EDITSTYLEOPTIONS)}
        titleBtnInner={"Delete"}
        onClikBtnInner={() =>
          handleRemove({
            url: "/v1/style_options",
            descSuccess: "Style Options data has been successfully deleted.",
          })
        }
        withHeader={true}
        withFooter={true}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
      >
        <DetailStyleOptionsPage data={dataRemove[0]} />
      </CustomModal>
    </>
  );
};
export default StyleOptionsPage;
